function initReview(expansion) {
  const problems = (expansion.proposedProblems || []).map(p => ({
    ...p,
    chosenSnomed: p.status === 'codeable' ? p.snomed : null,
    committable: p.status === 'codeable',
    checked: p.status === 'codeable',
  }));
  const admins = (expansion.proposedAdministrations || []).map(a => ({
    ...a, acked: !a.allergyConflict, checked: !a.allergyConflict,
  }));
  return { expandedNarrative: expansion.expandedNarrative, problems, admins };
}
function _clone(s) { return { expandedNarrative: s.expandedNarrative, problems: s.problems.map(p => ({ ...p })), admins: s.admins.map(a => ({ ...a })) }; }
function toggleProblem(s, i) { const n = _clone(s); const p = n.problems[i]; if (p.committable) p.checked = !p.checked; return n; }
function chooseOption(s, i, snomed) {
  const n = _clone(s); const p = n.problems[i];
  const opt = (p.options || []).find(o => o.snomed === snomed);
  if (opt) { p.chosenSnomed = snomed; p.chosenName = opt.name; p.committable = true; }
  return n;
}
function toggleAdmin(s, i) { const n = _clone(s); const a = n.admins[i]; if (!a.allergyConflict || a.acked) a.checked = !a.checked; return n; }
function ackAllergy(s, i) { const n = _clone(s); n.admins[i].acked = true; return n; }
function toCommitPayload(s) {
  const problems = s.problems.filter(p => p.checked && p.committable).map(p => {
    if (p.status === 'codeable') return { snomed: p.snomed, icd10: p.icd10, description: p.description };
    const opt = (p.options || []).find(o => o.snomed === p.chosenSnomed) || {};
    return { snomed: p.chosenSnomed, description: opt.name || p.term }; // tier-2: SNOMED-only (no icd10)
  });
  const administrations = s.admins.filter(a => a.checked && (!a.allergyConflict || a.acked)).map(a => ({
    drug: a.drug, dose: a.dose || null, route: a.route || null, isVaccine: !!a.isVaccine, cvx: a.cvx || null,
    administeredInOffice: a.administeredInOffice !== false, icd10: a.icd10 || null,
  }));
  return { problems, administrations };
}
module.exports = { initReview, toggleProblem, chooseOption, toggleAdmin, ackAllergy, toCommitPayload };
